import React from "react";
import { Container } from "./Layout.styled";

const Layout = ({ className, children, height, overflowY, scrollSnapType, overflowX, scrollPaddingTop }) => {
  /** JSDOCS */
  return (
    <Container
      className={className}
      height={height}
      overflowY={overflowY}
      overflowX={overflowX}
      scrollSnapType={scrollSnapType}
      scrollPaddingTop={scrollPaddingTop}
    >
      {children}
    </Container>
  );
};

export default Layout;
